const AUDIO_VOLUME_SLIDER = "audio-volume-slider";
export {
  AUDIO_VOLUME_SLIDER
};
//# sourceMappingURL=data-hooks.js.map
